import type { UseAudienceInfiniteQueryArgs } from "./useAudienceInfiniteQuery";
import { useAudienceInfiniteQuery } from "./useAudienceInfiniteQuery";

const activeConnectionFilter = {
  id: "connections-active",
  key: "connections",
  status: "active",
};

export const useActiveConnections = (args?: UseAudienceInfiniteQueryArgs) =>
  useAudienceInfiniteQuery({
    filters: [activeConnectionFilter, ...(args?.filters ?? [])],
    ...args,
  });
